// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentTitleFragmentDoc } from './content/ContentTitle.fragment.generated';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
export const ComponentInstagramPostsFragmentDoc = gql`
    fragment componentInstagramPosts on ComponentInstagramPosts {
  preTitle
  title {
    ...componentTitle
  }
  instagramUser
  instagramUserLink
  posts {
    image {
      ...imageLarge
    }
    link
  }
}
    ${ComponentTitleFragmentDoc}
${ImageLargeFragmentDoc}`;